import Link from 'components/shared/Link/Link';
import Media from 'components/shared/Media/Media';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { CanvasNavItemProps } from './types';

interface CanvasNavItemComponentProps {
  item: CanvasNavItemProps;
}

const CanvasNavItem = ({ item }: CanvasNavItemComponentProps) => {
  const { sys, icon, link } = item;

  // The item copy is the link's label; a link resolves from either a raw URL or an internal page.
  if (!link?.label || (!link?.url && !link?.internalPage)) return null;

  return (
    <li className="sm:min-w-[246px] sm:flex-1">
      <Link
        href={link?.url}
        internalPage={link?.internalPage}
        isSubnav
        className="flex items-center gap-6 transition-opacity hover:opacity-80 focus-visible:opacity-80">
        {icon?.url && (
          <div className="relative size-18 shrink-0" {...liveUpdateAttrs(sys?.id, 'icon')}>
            <Media media={icon} roundedImage={false} className="size-full object-contain" />
          </div>
        )}
        <div className="font-sans text-label-saans" {...liveUpdateAttrs(link?.sys?.id, 'label')}>
          {link?.label}
        </div>
      </Link>
    </li>
  );
};

export default CanvasNavItem;
